
  if ($(".home-background")) {

    var rand = Math.floor(Math.random()*3);

    tabUrl = ["url(/web/public/img/prestige/main-bg.jpg)", "url(/web/public/img/prestige/second-bg.jpg)", "url(/web/public/img/prestige/last-bg.jpg)"]

    $(".home-background").css("background-image", tabUrl[rand])

  };